import React, { useEffect, useState } from 'react'
import { Box, Button, Container, Dialog, DialogContent, DialogTitle, Grid, IconButton, MenuItem, Switch, TextField, Tooltip, Typography, styled } from '@mui/material'
import { Formik } from 'formik'
import * as Yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { toast } from 'react-toastify';

export default function DoctorDialog({ dialogOpen, setDialogOpen, updateID, setUpdateID }) {
    const [doctorData, setDoctorData] = useState({
        doctorName: "",
        doctorPhone: "",
        doctorRole: 0,
        status: true
    })
    const [isUpdate, setIsUpdate] = useState(false);

    useEffect(() => {
        if (updateID > 0) {
            GetDoctorDetailByID();
        }
    }, [updateID])

    function handleClose() {
        setDialogOpen(false);
        ClearData();
        setIsUpdate(false);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        setDoctorData({
            ...doctorData,
            [e.target.name]: value
        })
    }

    function handleStatusChange() {
        setDoctorData({
            ...doctorData,
            status: !doctorData.status
        })
    }

    function ClearData() {
        setDoctorData({
            doctorName: "",
            doctorPhone: "",
            doctorRole: 0,
            status: true
        })
    }

    function UploadDoctor() {
        if (isUpdate) {
            const updateModel = {
                doctorName: doctorData.doctorName.trim(),
                doctorPhone: doctorData.doctorPhone,
                doctorRole: doctorData.doctorRole,
                status: doctorData.status ? 1 : 0,
                doctorID: updateID
            }
            axios.put('https://serverfourpaws.ccsoftwares.com/Doctor/updateDotor', updateModel).then((res) => {
                if (res.data.affectedRows > 0) {
                    handleClose();
                    setUpdateID(0);
                    toast.success("Doctor Updated successfully!")
                }
            })
        } else {
            const SaveModel = {
                doctorName: doctorData.doctorName.trim(),
                doctorPhone: doctorData.doctorPhone,
                doctorRole: doctorData.doctorRole,
                status: doctorData.status ? 1 : 0
            }
            //console.log(SaveModel)
            axios.post('https://serverfourpaws.ccsoftwares.com/Doctor/createDotor', SaveModel).then((res) => {
                if (res.data > 0) {
                    handleClose();
                    toast.success("Doctor Added successfully!")
                } else {
                    toast.error("Doctor Adding unsuccessfully!")
                }
            })
        }
    }

    function GetDoctorDetailByID() {
        axios.get(`https://serverfourpaws.ccsoftwares.com/Doctor/getDoctorDetailByID/${updateID}`).then((res) => {
            if (res.data.length > 0) {
                setDoctorData({
                    ...doctorData,
                    doctorName: res.data[0].Name,
                    doctorPhone: res.data[0].Phone,
                    doctorRole: res.data[0].Role,
                    status: res.data[0].IsActive === 1 ? true : false
                })
                setIsUpdate(true);
            }
        })
    }

    return (
        <Dialog
            aria-labelledby="customized-dialog-title"
            open={dialogOpen}
            fullWidth={true}         // Ensures the dialog uses the full width of the container
            maxWidth='md'
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                {isUpdate ? 'Update Doctor' : 'Add Doctor'}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon sx={{ color: 'black' }} />
            </IconButton>
            <DialogContent dividers>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            doctorName: doctorData.doctorName,
                            doctorPhone: doctorData.doctorPhone,
                            doctorRole: doctorData.doctorRole,
                            status: doctorData.status
                        }}

                        validationSchema={
                            Yup.object().shape({
                                doctorName: Yup.string()
                                    .required('Doctor Name is required')
                                    .test('no-leading-space', 'Doctor Name cannot start with a space', value => value && value.trim().length > 0),
                                doctorPhone: Yup.string()
                                    .required('Doctor Contact Number is required')
                                    .matches(/^\d{10}$/, 'Doctor Contact Number must be exactly 10 digits'),
                                doctorRole: Yup.number()
                                    .required('Doctor role is required')
                                    .test('valid-selection', 'Please select a valid doctor role', value => value !== 0),

                            })
                        }
                        onSubmit={() => UploadDoctor()}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Grid container spacing={2}>
                                        <Grid item md={4} xs={12}>
                                            <TextField
                                                fullWidth
                                                error={Boolean(touched.doctorName && errors.doctorName)}
                                                helperText={touched.doctorName && errors.doctorName}
                                                // onBlur={handleBlur}
                                                label="Doctor Name *"
                                                name='doctorName'
                                                value={doctorData.doctorName}
                                                id='doctorName'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                                type='text'
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <TextField
                                                fullWidth
                                                error={Boolean(touched.doctorPhone && errors.doctorPhone)}
                                                helperText={touched.doctorPhone && errors.doctorPhone}
                                                // onBlur={handleBlur}
                                                label="Phone Number *"
                                                name='doctorPhone'
                                                value={doctorData.doctorPhone}
                                                id='doctorPhone'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                                type='text'
                                                onKeyDown={(e) => {
                                                    const value = e.target.value;
                                                    if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
                                                        e.preventDefault();
                                                    }
                                                    if (value.length >= 10 && e.key !== 'Backspace' && e.key !== 'Delete') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                            <TextField
                                                select
                                                fullWidth
                                                error={Boolean(touched.doctorRole && errors.doctorRole)}
                                                helperText={touched.doctorRole && errors.doctorRole}
                                                onBlur={handleBlur}
                                                label="Doctor Role *"
                                                name='doctorRole'
                                                value={doctorData.doctorRole}
                                                id='doctorRole'
                                                onChange={(e) => handleChange(e)}
                                                variant="outlined"
                                                size="small"
                                            >
                                                <MenuItem key={0} value={0}>Select Doctor Type</MenuItem>
                                                <MenuItem key={1} value={1}>Intern</MenuItem>
                                                <MenuItem key={2} value={2}>Part Time</MenuItem>
                                                <MenuItem key={3} value={3}>Full Time</MenuItem>
                                            </TextField>
                                        </Grid>
                                        <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                                            <Typography>Active</Typography>
                                            &nbsp;
                                            <Switch
                                                checked={doctorData.status}
                                                onChange={handleStatusChange}
                                                status="status"
                                                label="Active"
                                            />
                                        </Grid>
                                        <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            {isUpdate ? null :
                                                <Button
                                                    variant="contained"
                                                    type='submit'
                                                    sx={{ width: '20%' }}
                                                    size='small'
                                                    onClick={ClearData}
                                                >
                                                    clear
                                                </Button>
                                            }
                                            &nbsp; &nbsp;
                                            <Button
                                                variant="contained"
                                                type='submit'
                                                sx={{ width: '20%' }}
                                                size='small'
                                            >
                                                {isUpdate ? 'Update' : 'Submit'}
                                            </Button>
                                        </Grid>

                                    </Grid>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </DialogContent>
        </Dialog>
    )
}
